import { CheckmarkIcon, FolderIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { UnCheckMarkIcon } from '@va/svg-visa-icons';
import classNames from 'classnames';
import { useMemo } from 'react';

export enum FEEDBACK_STATUS_ENUM {
  INACTIVE = 1,
  DRAFT = 2,
  ACTIVE = 3,
}

export const FeedbackStatusCell = ({ status }: { status: FEEDBACK_STATUS_ENUM }) => {
  const translate = useTranslate();

  const getIcon = useMemo(() => {
    if (status === FEEDBACK_STATUS_ENUM.DRAFT) {
      return <FolderIcon className='h-18px w-18px' color='#3C3C3C' />;
    }
    if (status === FEEDBACK_STATUS_ENUM.INACTIVE) {
      return <UnCheckMarkIcon className='h-18px w-18px' color='#EDAB26' />;
    }
    return <CheckmarkIcon className='h-18px w-18px' color='#06A25A' />;
  }, [status]);

  const getStatusText = useMemo(() => {
    if (status === FEEDBACK_STATUS_ENUM.DRAFT) {
      return translate('feedback.status.draft');
    }
    if (status === FEEDBACK_STATUS_ENUM.INACTIVE) {
      return translate('feedback.status.inactive');
    }
    return translate('feedback.status.active');
  }, [status, translate]);

  return (
    <div
      className={classNames(
        'inline-flex items-center gap-7.5px py-9px pl-3 pr-15px text-15 leading-24 font-medium group-hover:bg-white rounded-24 whitespace-nowrap',
        { 'bg-green-apple text-green-pure': status === FEEDBACK_STATUS_ENUM.ACTIVE },
        { 'bg-white-snow text-gray-charcoal': status === FEEDBACK_STATUS_ENUM.DRAFT },
        { 'bg-fuel-yellow-faded text-fuel-yellow': status === FEEDBACK_STATUS_ENUM.INACTIVE },
      )}
    >
      {getIcon}
      <div>{getStatusText}</div>
    </div>
  );
};
